import {createAction} from "redux-act";

export const PlaygroundDashboardAction = createAction<{ namespace: string, playgroundId: number }>("Playground Dashboard");
export const PlaygroundDashboardRequestAction = createAction("Playground Dashboard - Request");
export const PlaygroundDashboardSuccessAction = createAction("Playground Dashboard - Success");
export const PlaygroundDashboardFailedAction = createAction("Playground Dashboard - Failed");
